import React from 'react';
import { Link } from 'gatsby';

import { ArrowPurple } from '../Icons/arrows';
import { FullDate, FullAddress } from './index';
import { useHover } from '../../utils/useHover';
import { mediaQueries } from 'src/style/breakpoints';
import { EventContainer, YellowLineHover } from './elements';
import { formattingSelectedEvent } from 'src/components/EventForm/formattingEvents';

/**
 * @type React.FunctionComponent<{ places: string, month: string, place: string,  city: string, address: string, hours: string}>
 */

const monthValue = [
  'jan.',
  'fév.',
  'mars',
  'avril',
  'mai',
  'juin',
  'juil.',
  'août',
  'sept.',
  'oct.',
  'nov.',
  'déc.',
];
const dayAndMonthFromDate = (dateValue) => {
  const date = new Date(dateValue);
  const day = date.getDate();
  const month = monthValue[date.getMonth()];

  return { day, month };
};

const getEventHours = (startTime, duration) => {
  const endHour = Number(startTime.substring(0, 2)) + duration + startTime.substring(2);
  return `${startTime} - ${endHour}`;
};

const EventItem = ({ date, place, address, city, startTime, duration, title, event, isOnline }) => {
  const [hoverRef, isHover] = useHover();
  const { day, month } = dayAndMonthFromDate(date);
  const hours = getEventHours(startTime, duration);

  const formattedEvent = formattingSelectedEvent(event);
  if (event.event_type || title === 'information meeting') {
    event.event_type = "Réunion d'information";
    title = "Réunion d'information";
  }

  return (
    <Link
      to="/evenements/inscription"
      state={formattedEvent}
      rel="noopener noreferrer"
      css={{
        textDecoration: 'none',
      }}
    >
      <EventContainer ref={hoverRef} isHover={isHover}>
        <YellowLineHover isHover={isHover} />
        <FullDate day={day} month={month} hours={hours} />

        <FullAddress
          place={place}
          address={address}
          city={city}
          hours={hours}
          title={title}
          isOnline={isOnline}
        />

        <div
          css={{
            [mediaQueries.phoneOnly]: {
              display: 'none',
            },
          }}
        >
          <ArrowPurple />
        </div>
      </EventContainer>
    </Link>
  );
};

export default EventItem;
